module.exports = __webpack_public_path__ + "static/media/orange-right.2989a9bd.png";